import {erpMethodApi} from "@dladio/service";

export const extendedApiSlice = erpMethodApi.injectEndpoints({
    endpoints: builder => ({
        syncOrders: builder.query({
            query: ({ method, body }) => ({
                url: `${method}`,
                method: 'POST',
                body: body
            })
        })
    })
})

export const { useSyncOrdersQuery } = extendedApiSlice